import { getComponentByType } from "@/pages/user/components/FormDesigner/ComponentList.js";

// 表单定义转text（指转换基础题型）
export function formToText(form) {
    if (!form.defJson) {
        return "解析失败";
    }

    let textArr = [];
    try {
        let formDef = JSON.parse(form.defJson);

        // 表单标题
        textArr.push(formDef.subject);
        textArr.push("\n");

        // 欢迎语
        if (formDef.description) {
            textArr.push("[欢迎语]" + formDef.description);
            textArr.push("\n");
        }
        textArr.push("\n");

        // 表单题目
        let itemList = formDef.itemList;
        for (let i = 0; i < itemList.length; i++) {
            let item = itemList[i];
            let component = getComponentByType(item.type);

            // 只允许导出基础题型
            if (component.group == "basic") {

                textArr.push("[" + component.name + "]" + item.title);
                textArr.push("\n");

                if (item.type === 'radio' ||
                    item.type === 'checkbox' ||
                    item.type === 'select') {
                    for (let j = 0; j < item.options.length; j++) {
                        let o = item.options[j];
                        textArr.push(o.label);
                        textArr.push("\n");
                    }
                }

                textArr.push("\n");
            }
        }

        return textArr.join("");
    } catch (error) {
        console.error("表单转文本失败", error);
        return "解析失败";
    }
}

export function getItemValueText(item) {
    let valueText = "";
    if (item.type === "input" || item.type === "textarea" || item.type === "date" || item.type === "time" || item.type === "month") {
        valueText = item.value;
    } else if (item.type === "radio" || item.type === "select") {
        let label = getLabelFromOptions(item.options, item.value);
        if (item.value === "other") {
            label += "(" + (item.otherText || "") + ")";
        }
        valueText = label;
    } else if (item.type === "checkbox") {
        if ("value" in item) {
            let labelArr = [];
            for (var ci = 0; ci < item.value.length; ci++) {
                let value = item.value[ci];
                let label = getLabelFromOptions(item.options, value);
                if (value === "other") {
                    label += "(" + (item.otherText || "") + ")";
                }
                labelArr.push(label);
            }
            valueText = labelArr.join(", ");
        }
    } else if (item.type === "rate") {
        if (item.value != undefined && item.value != null && item.value != "") {
            valueText = item.value + "分";
        }
    } else if (item.type === "matrix-radio") {
        let textArr = [];
        for (let mri = 0; mri < item.rows.length; mri++) {
            let row = item.rows[mri];
            let value = row.value;
            let label = "";
            if (value) {
                label = getLabelFromOptions(item.options, value);
            }
            textArr.push(row.title + "：" + label);
        }
        valueText = textArr.join("\n");
    } else if (item.type === "matrix-checkbox") {
        let textArr = [];
        for (let mcri = 0; mcri < item.rows.length; mcri++) {
            let row = item.rows[mcri];
            let value = row.value;
            let labelArr = [];
            if (value && value instanceof Array) {
                for (var mcoi = 0; mcoi < value.length; mcoi++) {
                    let v = value[mcoi];
                    let label = getLabelFromOptions(item.options, v);
                    labelArr.push(label);
                }
            }
            textArr.push(row.title + "：" + labelArr.join(", "));
        }
        valueText = textArr.join("\n");
    } else if (item.type === "matrix-rate") {
        let textArr = [];
        for (let mri = 0; mri < item.rows.length; mri++) {
            let row = item.rows[mri];
            let value = row.value;
            let label = "";
            if (value) {
                label = value + "分";
            }
            textArr.push(row.title + "：" + label);
        }
        valueText = textArr.join("\n");
    } else if (item.type === "img-upload" || item.type === "file-upload") {
        valueText = "";
        if (item.value) {
            let arr = JSON.parse(item.value);
            if (arr && arr instanceof Array && arr.length > 0) {
                if (item.type === "img-upload") {
                    valueText = arr.length + "张图片";
                } else if (item.type === "file-upload") {
                    valueText = arr.length + "份文件";
                }
            }
        }
    }
    return valueText;
}

export function getLabelFromOptions(options, value) {
    for (var i = 0; i < options.length; i++) {
        let option = options[i];
        if (option.value === value) {
            return option.label;
        }
    }
}

/**
 * 旧的提交记录回填到新的表单定义上
 * @param {*} newDef 新的表单定义
 * @param {*} oldSubmit 旧的提交记录
 */
export function oldSubmitFillNewDef(newDef, oldSubmit) {
    for (let i = 0; i < newDef.itemList.length; i++) {
        let newItem = newDef.itemList[i];
        for (let j = 0; j < oldSubmit.itemList.length; j++) {
            let oldItem = oldSubmit.itemList[j];
            if (oldItem.value == undefined || oldItem.value == null || oldItem.value == "" || oldItem.value == []) {
                continue;
            }
            if (newItem.id == oldItem.id) { // 相同题目
                if (newItem.type === "input"
                    || newItem.type === "textarea"
                    || newItem.type === "date"
                    || newItem.type === "time"
                    || newItem.type === "month"
                    || newItem.type === "img-upload"
                    || newItem.type === "file-upload") {
                    newItem.value = oldItem.value;
                } else if (newItem.type === "radio" || newItem.type === "select") {
                    for (var k = 0; k < newItem.options.length; k++) { // 遍历新选项
                        let optionVal = newItem.options[k].value;
                        if (optionVal == oldItem.value) { // 新选项中仍存在旧选择对应的选项
                            newItem.value = oldItem.value; // 旧值赋值给新题目
                            if (oldItem.otherText) {
                                newItem.otherText = oldItem.otherText;
                            }
                        }
                    }
                } else if (newItem.type === "checkbox") {
                    newItem.value = [];
                    for (var m = 0; m < oldItem.value.length; m++) {
                        let oldOptionVal = oldItem.value[m]; // 旧选择中的一个
                        for (var n = 0; n < newItem.options.length; n++) {
                            let optionVal = newItem.options[n].value;
                            if (optionVal == oldOptionVal) { // 新选项中仍存在该选择
                                newItem.value.push(optionVal); // 加入新题目的选择结果中
                            }
                        }
                    }
                    if (oldItem.otherText) {
                        newItem.otherText = oldItem.otherText;
                    }
                } else if (newItem.type === "rate") {
                    if (newItem.max >= oldItem.value) {
                        newItem.value = oldItem.value;
                    }
                } else if (newItem.type === "matrix-radio") {
                    // 匹配规则：
                    // 1、先匹配新旧题目的行是否一致
                    // 2、再跟据选项保留情况，将旧行内的值赋给新行

                    // 遍历新行
                    for (let nmri = 0; nmri < newItem.rows.length; nmri++) {
                        let newRow = newItem.rows[nmri];
                        for (var omri = 0; omri < oldItem.rows.length; omri++) {
                            let oldRow = oldItem.rows[omri];
                            if (newRow.id == oldRow.id) { // 新旧行id相同
                                // 判断选项一致情况，一致就将旧值赋给新行 -- start
                                for (var nmrio = 0; nmrio < newItem.options.length; nmrio++) { // 遍历新选项
                                    let optionVal = newItem.options[nmrio].value;
                                    if (optionVal == oldRow.value) { // 新选项中仍存在旧选择对应的选项
                                        newRow.value = oldRow.value;
                                    }
                                }
                            }
                        }
                    }
                    newItem.value = JSON.stringify(newItem.rows);
                } else if (newItem.type === "matrix-checkbox") {
                    // 匹配规则：
                    // 1、先匹配新旧题目的行是否一致
                    // 2、再跟据选项保留情况，将旧行内的值赋给新行

                    // 遍历新行
                    for (let nmci = 0; nmci < newItem.rows.length; nmci++) {
                        let newRow = newItem.rows[nmci];
                        for (var omci = 0; omci < oldItem.rows.length; omci++) {
                            let oldRow = oldItem.rows[omci];

                            if (newRow.id == oldRow.id && oldRow.value != undefined) { // 新旧行id相同
                                newRow.value = [];
                                for (var omciv = 0; omciv < oldRow.value.length; omciv++) {
                                    let oldOptionVal = oldRow.value[omciv]; // 旧选择中的一个
                                    for (var nmcio = 0; nmcio < newItem.options.length; nmcio++) {
                                        let optionVal = newItem.options[nmcio].value;
                                        if (optionVal == oldOptionVal) { // 新选项中仍存在该选择
                                            newRow.value.push(optionVal); // 加入新题目的选择结果中
                                        }
                                    }
                                }
                            }
                        }
                    }
                    newItem.value = JSON.stringify(newItem.rows);
                } else if (newItem.type === "matrix-rate") {

                    // 匹配规则：
                    // 1、先匹配新旧题目的行是否一致
                    // 2、再跟据选项保留情况，将旧行内的值赋给新行

                    // 遍历新行
                    for (let nmratei = 0; nmratei < newItem.rows.length; nmratei++) {
                        let newRow = newItem.rows[nmratei];
                        for (var omratei = 0; omratei < oldItem.rows.length; omratei++) {
                            let oldRow = oldItem.rows[omratei];
                            if (newRow.id == oldRow.id) { // 新旧行id相同
                                if (newItem.max >= oldRow.value) {
                                    newRow.value = oldRow.value;
                                }
                            }
                        }
                    }
                    newItem.value = JSON.stringify(newItem.rows);
                }
            }
        }
    }
    return newDef;
}